import { render, staticRenderFns } from "./history-detail.vue?vue&type=template&id=7f8b930a&scoped=true&"
import script from "./history-detail.vue?vue&type=script&lang=js&"
export * from "./history-detail.vue?vue&type=script&lang=js&"
import style0 from "./history-detail.vue?vue&type=style&index=0&id=7f8b930a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b930a",
  null
  
)

export default component.exports